import { createActionGroup, props } from '@ngrx/store';
import {
  CopilotActiveRun,
  CopilotExecutionStatus,
  Message,
} from '../models/copilot.models';
import { ConversationalBtmRunMessage } from '../btm';

export const CopilotActions = createActionGroup({
  source: 'Copilot',
  events: {
    'Select Client': props<{ clientId: string }>(),
    'Select Conversation': props<{
      clientId: string;
      conversationId: string;
      view?: 'active' | 'archived';
    }>(),
    'Set Conversation Context': props<{
      clientId: string;
      conversationId: string;
      clientGuid: string;
    }>(),

    'Load Messages': props<{
      clientId: string;
      conversationId: string;
      forceRefresh?: boolean;
    }>(),
    'Load Messages Success': props<{
      clientId: string;
      conversationId: string;
      messages: Message[];
      executionStatus: CopilotExecutionStatus;
      activeRun?: CopilotActiveRun;
      agentIdentifier?: string;
    }>(),
    'Load Messages Failure': props<{
      clientId: string;
      conversationId: string;
      error: unknown;
    }>(),

    'Send Message': props<{
      clientId: string;
      conversationId: string;
      content: string;
      optimisticUserId: string;
      startedAt: string;
      clientGuid?: string;
    }>(),
    'Message Received': props<{
      clientId: string;
      conversationId: string;
      message: Message;
      owner_id?: string;
    }>(),
    'Submission Accepted': props<{
      clientId: string;
      conversationId: string;
      activeRun: CopilotActiveRun;
    }>(),
    'Run Connection Changed': props<{
      clientId: string;
      conversationId: string;
      status: CopilotActiveRun['status'];
      attempt: number;
      lastEventId?: string;
      error?: string;
    }>(),
    'Run Snapshot Received': props<{
      clientId: string;
      conversationId: string;
      runId: string;
      messages: Message[];
      lastEventId?: string;
      error?: string;
    }>(),
    'Run Reconciled': props<{
      clientId: string;
      conversationId: string;
      messages: Message[];
      executionStatus: CopilotExecutionStatus;
      error?: string;
    }>(),
    'Run Failed': props<{
      clientId: string;
      conversationId: string;
      optimisticUserId?: string;
      error: string;
    }>(),
    'Run Disconnected': props<{
      clientId: string;
      conversationId: string;
      error: string;
    }>(),
    'Resume Run': props<{
      clientId: string;
      conversationId: string;
      activeRun: CopilotActiveRun;
      initialMessages: ConversationalBtmRunMessage[];
    }>(),

    'Archive Conversation': props<{
      clientId: string;
      conversationId: string;
    }>(),
    'Close Conversation': props<{ clientId: string; conversationId: string }>(),
    'Trigger Client Highlight': props<{ clientId: string }>(),
    'Clear Client Highlight': props<{ clientId: string }>(),
    'Clear Client': props<{ clientId: string }>(),
    'Update Input Text': props<{
      clientId: string;
      conversationId: string;
      text: string;
    }>(),
    'Clear Input Text': props<{ clientId: string; conversationId: string }>(),
    'Trigger Conversation Highlight': props<{
      clientId: string;
      conversationId: string;
    }>(),
    'Clear Conversation Highlight': props<{
      clientId: string;
      conversationId: string;
    }>(),

    'Update Chat Search Query': props<{
      clientId: string;
      conversationId: string;
      query: string;
    }>(),
    'Set Chat Search Active Match Index': props<{
      clientId: string;
      conversationId: string;
      activeMatchIndex: number;
    }>(),
    'Clear Chat Search': props<{ clientId: string; conversationId: string }>(),
  },
});
